// time-ago.pipe.ts
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'timeAgo',
    standalone: false
})
export class TimeAgoPipe implements PipeTransform {
    transform(value: string): string {
        const date = new Date(value);
        const now = new Date();
        const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

        let interval = Math.floor(seconds / 31536000);

        if (interval >= 1) {
            return interval === 1 ? `${interval} year ago` : `${interval} years ago`;
        }

        interval = Math.floor(seconds / 2592000);
        if (interval >= 1) {
            return interval === 1 ? `${interval} month ago` : `${interval} months ago`;
        }

        interval = Math.floor(seconds / 86400);
        if (interval >= 1) {
            return interval === 1 ? `${interval} day ago` : `${interval} days ago`;
        }

        interval = Math.floor(seconds / 3600);
        if (interval >= 1) {
            return interval === 1 ? `${interval} hour ago` : `${interval} hours ago`;
        }

        interval = Math.floor(seconds / 60);
        if (interval >= 1) {
            return interval === 1 ? `${interval} minute ago` : `${interval} minutes ago`;
        }

        return `${Math.floor(seconds)} seconds ago`;
    }
}
